import { Component, OnInit, ViewChild } from '@angular/core';
import { ScApiService, ScFileButtonComponent, ScUploadService } from '@sc-ui';
import { UserService } from 'src/services/user.service';
import { LocalizationService } from 'src/services/localization.service';
import { texts } from './settings.texts';

@Component({
  standalone: false,
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  texts = texts;

  oldPassword: string;

  newPassword: string;

  changePasswordSuccess: boolean;

  changePasswordError: any;

  isChangingPassword = false;

  isSaving = false;

  saveSuccess = false;

  isSavingNotifications = false;

  saveNotificationsSuccess = false;

  isSavingLanguage = false;

  saveLanguageSuccess = false;

  user : any;

  settings : any;

   avatarUri : '';

   isUploadingImage = false;

   show = 'profile';

   @ViewChild('fileButton')
   fileButton : ScFileButtonComponent


  constructor(
    private api : ScApiService,
    private uploadService : ScUploadService,
    private userService : UserService,
    private localization : LocalizationService) { }

  ngOnInit(): void {
    this.api.get('me').subscribe(d => {
      this.user = d;
    });

    this.api.get('me/settings').subscribe(d => {
      this.settings = d;
      if (!this.settings.Language) this.settings.Language = this.localization.language;
    })
  }

  onUploadError(e)
  {
    console.log(e);
  }

  onUploadSuccess(e)
  {
    console.log(e);
  }

  upload(files) {
    this.isUploadingImage = true;
    this.uploadService.upload(files, (d: any) => {
      this.avatarUri = d.Uri;
      this.user.Image = d.Uri;
      this.isUploadingImage = false;
    });
  }

  clearImage()
  {
    if (!this.user) return;
    this.user.Image = null;
    this.fileButton.reset();
  }

  save()
  {
    this.isSaving = true;

    this.api.put('me', this.user).subscribe(d => {
      this.isSaving = false;
      this.saveSuccess = true;
      this.userService.load();
      setTimeout(() => { 
        this.saveSuccess = false;
      }, 5000);
    });
  }

  saveNotifications()
  {
    this.isSavingNotifications = true;

    this.api.put('me/settings', this.settings).subscribe(d => {
      this.userService.me.Settings = this.settings;
      this.isSavingNotifications = false;
      this.saveNotificationsSuccess = true;      
      setTimeout(() => { 
        this.saveNotificationsSuccess = false;
      }, 5000);
    });
  }

  saveLanguage()
  {
    this.isSavingLanguage = true;

    this.api.put('me/settings', this.settings).subscribe(d => {
      this.userService.me.Settings = this.settings;
      this.localization.setLanguage(this.settings.Language);
      this.isSavingLanguage = false;
      this.saveLanguageSuccess = true;
      setTimeout(() => {
        this.saveLanguageSuccess = false;
      }, 5000);
    });
  }

  changePassword() {

    if (!this.oldPassword)
    {
      this.changePasswordError = texts.password.errors.missingOld;
      return;
    }

    if (!this.newPassword)
    {
      this.changePasswordError = texts.password.errors.missingNew;
      return;
    }

    this.isChangingPassword = true;
    this.changePasswordError = null;

    this.api.changePassword(this.oldPassword, this.newPassword).subscribe(d => {
      
      this.newPassword = "";
      this.oldPassword = "";
      this.isChangingPassword = false;
      this.changePasswordSuccess = true;

      

      setTimeout(() => { 
        this.changePasswordSuccess = false;
      }, 5000);

    }, error => {

      console.error(error);
      this.isChangingPassword = false;

      if (error.error) {
        this.changePasswordError = error.error;
      }
      else {
        this.changePasswordError = texts.password.errors.generic;
      }
    })
  }

}